import api from '@/api/index.js'

const fare_groups = {
  state: {
    loading: false,
    data: [],
    updating: false,
    error: null,
  },

  mutations: {
    SET_FARE_GROUPS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_FARE_GROUPS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_FARE_GROUPS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_FARE_GROUPS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadFareGroups({commit}) {
      commit('SET_FARE_GROUPS_ERROR', null)
      commit('SET_FARE_GROUPS_LOADING', true)
      return api.get(`fare-groups?limit=150&offset=0`)
        .then((response) => {
          commit('SET_FARE_GROUPS', response)
        })
        .catch((error) => {
          commit('SET_FARE_GROUPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateFareGroup({commit}, payload) {
      commit('SET_FARE_GROUPS_UPDATING', true);
      commit('SET_FARE_GROUPS_ERROR', null)
      return api.post(`fare-groups`, payload)
        .then((response) => {
          commit('SET_FARE_GROUPS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_FARE_GROUPS_ERROR', error);
          commit('SET_FARE_GROUPS_UPDATING', false);
        })
    },
  },
}

export default fare_groups
